// // src/features/Reports/Reports.jsx
import React from 'react';
import FilterReport from './components/FilterReport';
import useReportsData from './hooks/useReportsData';

const Reports = () => {
    const { data, loading, error } = useReportsData();

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error loading reports</div>;

    return (
        <div>
            <FilterReport />
        </div>
    );
};

export default Reports;

// const Reports = () => {
//     return <div>Reports Page</div>;
// };

// export default Reports;